import { render, staticRenderFns } from "./envelope.vue?vue&type=template&id=0df3522a&scoped=true&"
var script = {}
import style0 from "./envelope.vue?vue&type=style&index=0&id=0df3522a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df3522a",
  null
  
)

export default component.exports